export default () => ({
  plans: [],
  planKeys: [],
  error: '',
  invoices: [],
  billing: [],
});
